import React from 'react'

import photo from "../../img/portrait.webp";
import { IoIosPin } from "react-icons/io";
import { IoPhonePortraitOutline } from "react-icons/io5";
import { IoMailOutline } from "react-icons/io5";

import {
    ContactContainer,
    ContactsTextWrapper,
    ContactWrapper,
    ContactRow,
    ContactsH1,
    ContactInfoContainer,
    ContactElement,
    ContactCard,
    ContactBottom,
    ContactsPortrait,
    ContactCardRight,
    ContactCardLeft,
    ContactElementText
} from './ContactElements'

const ContactSection = () => {
    return (
        <div id="contact">
            <ContactContainer>
                <ContactsTextWrapper>
                    <ContactsH1>Contact us</ContactsH1>
                </ContactsTextWrapper>
                <ContactWrapper>
                    <ContactRow>
                        <ContactInfoContainer>
                           <ContactCard>
                                <ContactCardRight>
                                    <ContactsPortrait src={photo}/>
                                </ContactCardRight>
                                <ContactCardLeft>
                                    <ContactElement>
                                        <h2>
                                            Luis Torres
                                        </h2>
                                    </ContactElement>
                                    <ContactElement>
                                    </ContactElement>

                                    <ContactElement>
                                        <IoPhonePortraitOutline style={{fontSize:' 1.5rem', marginRight: '1rem'}}/>
                                        <ContactElementText>
                                        619-960-5293
                                            
                                        </ContactElementText>
                                    </ContactElement>

                                    <ContactElement>
                                        <IoMailOutline style={{fontSize:' 1.5rem', marginRight: '1rem'}}/>
                                        <ContactElementText>
                                        TrustedProcessServices@gmail.com

                                        </ContactElementText>
                                        
                                    </ContactElement>
                                    <ContactElement>
                                        <IoMailOutline style={{fontSize:' 1.5rem', marginRight: '1rem'}}/>
                                       <ContactElementText>
                                        LuisTorres@TrustedProcessServices.com
                                       </ContactElementText>
                                        
                                    </ContactElement>
                                </ContactCardLeft>
                           </ContactCard>
                            <ContactBottom></ContactBottom>
                           
                        </ContactInfoContainer>
                    </ContactRow>
                </ContactWrapper>
            </ContactContainer>
        </div>
    )
}

export default ContactSection
